import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectChangeRequestData = state => selectState(state).data;
export const selectChangeRequestLoading = state => selectState(state).loading;
export const selectFetchChangeRequestLoading = state => selectState(state).fetchLoading;
export const selectChangeRequestSaveLoading = state => selectState(state).saveLoading;
export const selectChangeRequestError = state => selectState(state).error;
export const selectChangeRequestFilterVisible = state => selectState(state).filterVisible;
export const selectChangeRequestFilters = state => selectState(state).filters;
export const selectTileView = state => selectState(state).tileView;

export const selectFilteredChangeRequests = createSelector(
  [selectChangeRequestData, selectChangeRequestFilters],
  (data, { searchText }) => {
    const q = (searchText || '').toLowerCase();
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key] ?? '').toLowerCase().includes(q),
      ),
    );
  },
);
